const defaultConfigs = {
	bgConfigPosition: 'left',
};
const template3Configs = {
	bgConfigPosition: 'right',
};

export default {
	default: defaultConfigs,
	template1: defaultConfigs,
	template2: defaultConfigs,
	template3: template3Configs,
	template4: defaultConfigs,
	template5: defaultConfigs,
	template6: defaultConfigs,
	template7: defaultConfigs,
};
